/**
 * Rewardful (https://r.wdfl.co/rw.js) define el global `Rewardful` sólo cuando el
 * script logra cargar. Los bloqueadores de anuncios / extensiones de privacidad lo
 * bloquean con frecuencia, y en ese caso leer el identificador pelado `Rewardful`
 * lanza un ReferenceError que rompe el flujo de login.
 *
 * Estos helpers nunca lanzan: si el script no está disponible devuelven null.
 */
const getRewardful = (): any => {
  try {
    return (window as any).Rewardful ?? null;
  } catch (error) {
    return null;
  }
};

export const getRewardfulReferral = (): string | null => getRewardful()?.affiliate ?? null;

export const getRewardfulCouponId = (): string | null => getRewardful()?.coupon?.id ?? null;
